import { formatDateTime } from '../../utils/historyView';
import './EntryContext.css';

function EntryContext({ entry }) {
    return (
        <div className="ai_chat_panel_insights_context" title={entry.prompt}>
            <span className="ai_chat_panel_insights_context_date">{formatDateTime(entry.createdAt)}</span>
            <span className="ai_chat_panel_insights_context_prompt">{entry.prompt || '(no prompt)'}</span>
        </div>
    );
}

export default EntryContext;
